export const listLegalProcessDocumentService = (fetch) => async (filters) => {
  try {
    const searchParams = new URLSearchParams(filters).toString();
    const response = await fetch({
      url: `/api/v1/siniestros-viales/documentos-procesos-juridicos?${searchParams}`,
    });

    return response;
  } catch (error) {
    console.error("Error fetching indicators:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};
